import { useMemo } from 'react';
import { useQuery } from 'react-apollo';

import getCardCategoryHierarchyQuery from '../graphql/queries/getCardCategoryHierarchy';

/**
 * Determines which CardCategories are worth drilling into, i.e. which ones have
 * sub-categories of their own (today: "Holiday Cards" and its eight seasonal children).
 *
 * CardCategory exposes `parent` but no children, so the whole active tree is fetched
 * once and inverted here rather than asking per category.
 *
 * @returns {{drillableCardCategoryIds: Set<string>, loading: boolean}}
 */
const useDrillableCardCategories = () => {
  const { data: { cardCategories } = {}, loading } = useQuery(
    getCardCategoryHierarchyQuery,
    { fetchPolicy: 'cache-first' },
  );

  const drillableCardCategoryIds = useMemo(
    () =>
      new Set(
        (cardCategories?.records ?? [])
          .map(cardCategory => cardCategory.parent?.id)
          .filter(Boolean),
      ),
    [cardCategories],
  );

  return { drillableCardCategoryIds, loading };
};

export default useDrillableCardCategories;
